import { cn } from "@/lib";
import { ReactNode } from "react";
import { FlexCenter } from "../ui";

interface ValueCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  className?: string;
}

const ValueCard = ({ title, description, icon, className }: ValueCardProps) => {
  return (
    <article className={cn("flex gap-5", className)}>
      <FlexCenter
        className={cn(
          "h-full max-h-10 w-full max-w-10 xl:max-h-14 xl:max-w-14",
        )}
      >
        {icon}
      </FlexCenter>
      <div className={cn("flex flex-col gap-2")}>
        <h2 className={cn("text-primary-main text-sm font-bold xl:text-base")}>
          {title}
        </h2>
        <p
          className={cn(
            "text-custom-gray-200 text-xs leading-5 lg:leading-normal xl:text-sm",
          )}
        >
          {description}
        </p>
      </div>
    </article>
  );
};

export default ValueCard;
